// 版本信息类型定义
export interface AppVersion {
  id: string;
  createdAt: string;
  updatedAt: string;

  // 基本信息
  version: string;          // 版本号 (如 v1.0.0)
  versionName: string;      // 版本名称
  platform: string;         // 平台 (macos-arm64/macos-intel/macos-universal)
  status: string;           // 状态 (draft/beta/stable/deprecated)

  // 更新信息
  changelog: string;        // 更新日志 (Markdown)
  forceUpdate: boolean;     // 是否强制更新
  minCompatVersion: string; // 最低兼容版本

  // 下载信息
  downloadUrl: string;      // 完整包下载链接 (OSS)
  incrementalUrl: string;   // 增量包下载链接 (从上一版本)
  fileSize: number;         // 文件大小 (bytes)
  fileMd5: string;          // 文件MD5
  incrementalSize: number;  // 增量包大小 (bytes)
  incrementalMd5: string;   // 增量包MD5

  // 发布信息
  releaseTime: string;      // 发布时间
  publisher: string;        // 发布人

  // 统计信息
  downloadCount: number;    // 下载次数
}

// API 响应类型
export interface ApiResponse<T> {
  status: number;
  msg: string;
  data: T;
}

// 平台类型
export enum Platform {
  MacOSARM64 = 'macos-arm64',
  MacOSIntel = 'macos-intel',
  MacOSUniversal = 'macos-universal'
}

// 版本状态
export enum VersionStatus {
  Draft = 'draft',
  Beta = 'beta',
  Stable = 'stable',
  Deprecated = 'deprecated'
}
